export const currency = {
    "usd": {
        "name": "US Dollars",
        "sign": "$"
    }
}